import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class CacheBusterInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Add cacheBuster if this is a GET request and doesn't appear to be using the keyed static cache.
        // The keyed static cache intentionally tries to use the browser's built-in caching.
        if (request.method === 'GET' && !/[?&]cacheKey\=\d+/.test(request.urlWithParams)) {
            request = request.clone({
                params: request.params.set('cacheBuster', Date.now().toString())
            });
        }
        return next.handle(request);
    }
}
